export { default } from '@material-ui/core/ListItem';

export type ListItemProps = import('@material-ui/core/ListItem').ListItemProps;
